// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_document_analyzer_link-module__container--4XlpM"};